<template>
  <v-row dense>
    <v-col cols="12" md="6">
      <v-switch
        v-model="settings.can_order_off"
        inset
        :label="$t('restaurant_order_off')"
        hide-details
      />
    </v-col>
    <v-col cols="12" md="6">
      <v-switch
        v-model="settings.receiving_orders"
        inset
        :label="$t('receiving_orders')"
        hide-details
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "GuestOrderSwitchesSection",
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
};
</script>
